import { BCMSRecord, BCMSDate, BCMSStateManagerCRUD, DisabledPrompt, Link, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { CustomAccountSelect, CustomSelectItem } from 'components/custom-ui/CustomSelect';
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import OSGStatementSearchItem from "components/workflows/OSGStatementsWorkflow/classes/OSGStatementSearchItem";
import OSGStatementTable, { OSGStatementView } from "./components/OSGStatementTable";
import MobileOSGStatementTable from "./components/MobileOSGStatementTable";
import Classes, { Account, Document } from "model";
import "./styles.css";
import "./mobile.css";


/**
 * @function OSGStatementsPage
 * @return {React.Component}
 * @exported true
 * @description The "OSG Statements" page.
 */
export default function OSGStatementsPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onChange: (id, prop, setVal) => val => {

    },

    onAccountChange: value => {
        let search = state.data.search;
        search.account = value === "all" ? value : value.id;
        let filtered = search.filter();

        BCMSStateManagerCRUD.init(state)
        .update([ "data", "search" ], filtered)
        .submit(setState);
    },

  });

  return (
    <PageContainer className="osg-statements-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = (controller) => {
    let branding = {};
    let options = {}
    let showAllAccountsOption = true;
    const firstAccountID = Account.initAll()[0].id;
    const documents = Document.sortDateAscending(Document.initAll());

    if(controller) {
        branding = controller.state.branding;
        options = controller.state.branding.options;
        showAllAccountsOption = options.allaccts_statements_abi22 === "true";
    }
  
    return {
        search: OSGStatementSearchItem.init({ 
            account: showAllAccountsOption ? "all" : `${ Account.initAll()[0].id }`,
            filtered: showAllAccountsOption ? documents : documents.filter(item => item.account.id === firstAccountID)
        }),
        branding: branding,
        showAllAccountsOption
    };
};

export const getDefaultUI = () => ({
    accountDD: { isActive: false }, 
});

function PageContent(props) {
    const { data, ui, onAccountChange } = useStateManager();
    const selectedAccount = data.search.account !== "" && data.search.account !== "all" ? Account.initByType(data.search.account) : data.search.account;
    const selectedAccountLabel = selectedAccount === "all" ? "" : `${ selectedAccount.number } - ${ selectedAccount.name }`;

    let statementRows = data.search.filtered.map((document, index) => <OSGStatementView
        key={ `statement_${ document.id }` }
        link={ 
            <DisabledPrompt>
                { document.date.format("m/d/Y") }
            </DisabledPrompt>
        }
        id={ document.id }
        accountNickname={ `${ document.account.nickname } ${ document.account.number }` }
        accountNumber={ document.account.number }
        documentName={ document.name }
        documentType={ document.type }
    />, []);

    if(statementRows.length === 0) {
        statementRows = <OSGStatementView
            key={ `statement_${ document.id }` }
            documentName={ `There are no statements available.` }
            showFullColspan="true"
        />;
    }

    const currYear = BCMSDate.init().yearInt;
    let years = [ <span className="set-width"><DisabledPrompt><Link className="year-link">{ `Recent Statements` }</Link></DisabledPrompt></span> ];

    for(let i = 0; i < 7; i++) {
        years.push(<span className="set-width"><DisabledPrompt><Link className="year-link">{ `${ currYear - i }` }</Link></DisabledPrompt></span>);
    }

  return (
    <PageContentView>
        <CenterContentContainer>
            <ContentHeaderView className="show-on-desktop" text="Statements" />
            <ContentHeaderView className="show-on-mobile" text="eStatements available in Desktop" />
            <div className="show-on-mobile">
                {
                    <MobileOSGStatementTable/>
                }
            </div>
            <div className="show-on-desktop desktop-table-view-container">
                {
                    <>
                        <FormContainer className="small-form-width">
                            <FormRowView text="Account:" className="form-row-view-account">
                                <CustomAccountSelect className="statements-account-select" value={ selectedAccount } accounts={ Account.initAll() } onChange={ onAccountChange }
                                active={ ui.accountDD.isActive } data-point="Account_DD">
                                    { data.showAllAccountsOption ? <CustomSelectItem value="all" className="all-option">All Accounts</CustomSelectItem> :  undefined }
                                </CustomAccountSelect>
                            </FormRowView>
                            <FormRowView text="">
                                <span className="description">{ `${ selectedAccountLabel }` }</span>
                                <span className="description description-2">{ `Statements are available online for up to 6 years` }</span>
                                <span className="flex-horizontal flex-container flex-wrap year-links-container">
                                    { years }
                                </span>
                            </FormRowView>
                        </FormContainer>
                        <OSGStatementTable>{ statementRows }</OSGStatementTable>
                    </>
                }
            </div>
        </CenterContentContainer>
    </PageContentView>
  );
}